import { defineComponent } from '@vue/composition-api';
import DpControlGroup from '../layout/ControlGroup.vue';
import DpLegendLabel from './LegendLabel.ts.vue';
export default defineComponent({
    name: 'DpLegend',
    components: {
        DpControlGroup,
        DpLegendLabel,
    },
    props: {
        items: { type: Array, default: () => [] },
    },
    setup(_, { emit }) {
        const toggleItem = (item, enabled) => {
            emit('toggle-item', {
                ...item,
                enabled,
            });
        };
        return {
            toggleItem,
        };
    },
});
